import { create } from 'zustand'

interface UIState {
  sidebarOpen: boolean
  membersPanelOpen: boolean
  modal: string | null
  modalData: any
  setSidebarOpen: (open: boolean) => void
  setMembersPanelOpen: (open: boolean) => void
  openModal: (modal: string, data?: any) => void
  closeModal: () => void
}

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: true,
  membersPanelOpen: true,
  modal: null,
  modalData: null,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setMembersPanelOpen: (open) => set({ membersPanelOpen: open }),
  openModal: (modal, data) => set({ modal, modalData: data }),
  closeModal: () => set({ modal: null, modalData: null }),
}))
